import { TERMS_AND_CONDITIONS, PRIVACY_POLICY } from 'routes/external'

import { InputPassword } from '~shared'
import { Input, Button, Typography, Link, Checkbox, Heading } from '~ui'

import styles from '../AuthForm.module.scss'

const { Text } = Typography

const SingUpFormComponent = ({
  values,
  errors,
  status,
  touched,
  loading,
  title,
  logInUrl,
  handleBlur,
  handleSubmit,
  handleChange,
}) => (
  <form onSubmit={handleSubmit} className={styles.form}>
    <Heading Tag="h3" uppercase colorGlow="g-green-darker" fontWeight={400}>
      {title}
    </Heading>
    <Text>
      Already have an account?{' '}
      <Link color="green" href={logInUrl}>
        Sign in
      </Link>
    </Text>

    <div className={styles['form-inputs']}>
      <Input
        id="email"
        name="email"
        type="email"
        onBlur={handleBlur}
        value={values.email}
        onChange={handleChange}
        error={touched.email && errors.email}
        placeholder="Email Address"
      />

      <InputPassword
        onBlur={handleBlur}
        value={values.password}
        onChange={handleChange}
        error={touched.password && errors.password}
      />
    </div>

    <div className={styles['form-terms-checkbox']}>
      <Checkbox
        name="terms"
        value="terms"
        onBlur={handleBlur}
        checked={values.terms}
        onChange={handleChange}
        label={
          <>
            {`By signing up you agree to Granted’s `}
            <Link href={TERMS_AND_CONDITIONS} color="green" target="_blank">
              Terms of Service
            </Link>
            {' and '}
            <Link href={PRIVACY_POLICY} color="green" target="_blank">
              Privacy Policy
            </Link>
            .
          </>
        }
      />
    </div>

    {touched.terms && errors.terms && (
      <Text color="red">You must accept the Terms and Conditions</Text>
    )}

    {!!status && <Text color="red">{status}</Text>}

    <Button variant="primary" type="submit" loading={loading}>
      Sign Up
    </Button>
  </form>
)

export default SingUpFormComponent
